import Vue from "vue";
import { Component, Emit } from "vue-property-decorator";
import { IProductViewModel, IPriceListViewModel, IContractViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { CustomerTypeEnum, HousingTypeEnum, TarificationIdEnum, ProcessTypeEnum, SubProcessTypeEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import PriceList from "./components/price-list.vue";
import { SectionChecker } from "../../Default/common/section";
import { IContractSettings } from "../../new-contract-vuex-store";

class Checker extends SectionChecker {
    constructor() {
        super();
        this.idProperties = [
            (contract: IContractViewModel) => contract.ProductId,
            (contract: IContractViewModel) => contract.PriceListId,
        ];
        this.validationIds = ["Product"];
    }
}
export const ProductSelectionChecker = new Checker();

@Component({
    components: {
        PriceList,
    },
})

export default class ProductSelection extends Vue {
    get contractSettings(): IContractSettings { return this.$store.state.contractSettings; }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get products(): IProductViewModel[] { return this.$store.state.products; }
    get selectedProduct(): IProductViewModel { return this.$store.state.selectedProduct; }
    get selectedPriceList(): IPriceListViewModel { return this.$store.state.selectedPriceList; }
    get preSelectedProductId(): number { return this.$store.state.preSelectedProductId; }
    get preSelectedPriceListId(): number { return this.$store.state.preSelectedPriceListId; }
    get showPricesWithVat(): boolean { return this.contract.CustomerType != CustomerTypeEnum.COMPANY; }
    get isFixedTerm(): boolean { return this.$store.state.products.PriceLists.FixedTerm; }
    selectProduct(payload: { product: IProductViewModel, priceList: IPriceListViewModel }) { return this.$store.dispatch("selectProduct", payload); }
    get housingType(): HousingTypeEnum { return this.$store.state.contract.HousingTypeId; }
    get tarification(): TarificationIdEnum { return this.$store.state.contract.TarificationId; }
    get processBrand(): string { return this.$store.state.Brand; }
    get selectedConinueWithSameProductId(): number { return this.$store.state.selectedConinueWithSameProductId; }
    get selectedConinueWithSamePriceListId(): number { return this.$store.state.selectedConinueWithSamePriceListId; }

    //get newContractOldProductId(): number { return this.getNewContractWithOldProducId(); }
    
    @Emit()
    productSelected(product: IProductViewModel, priceList: IPriceListViewModel) { }

    HousingTypeEnum: typeof HousingTypeEnum = HousingTypeEnum;
    TarificationIdEnum: typeof TarificationIdEnum = TarificationIdEnum;

    constructor() {
        super();
    }

    //getNewContractWithOldProducId(): number {
    //    let result = 0
        
    //    if (this.contract.ProcessType == ProcessTypeEnum.MOVINGPROCESS && this.contract.SubProcessType == SubProcessTypeEnum.MOVINGWITHOLDCONTRACTPRODUCT) {
    //        if (this.contract.CustomerContracts && this.contract.CustomerContracts.length == 1) {
    //            if (this.products.find(x => x.Id == this.contract.CustomerContracts[0].ProductId)) {
    //                return this.contract.CustomerContracts[0].ProductId;
    //            }
    //        }
    //    }
    //    else {

    //    }
    //    return result;
    //}

    selectClicked(product: IProductViewModel, priceList: IPriceListViewModel) {
        this.selectProduct({ product: product, priceList: priceList })
            .then(() => this.productSelected(product, priceList));
    }

    isSelected(product: IProductViewModel, priceList: IPriceListViewModel) {
        if (this.selectedProduct != null && this.selectedPriceList != null)
            return this.selectedProduct.Id == product.Id && this.selectedPriceList.Id == priceList.Id;
        return false;
    }

    isContinueContract(): boolean {
        // return true, if the selection in the moveoutprocessselector is "Jatkan nykyistä sopimusta", otherwise false
        return (this.contract.ContractToNewAddressSelection == 2);
    }

    // jos pitää näyttää tuote ja hinnasto silloin kun ovat valideja
    //productdHasValidPricelist(productId: number): boolean {
    //    if (productId != this.selectedConinueWithSameProductId || this.selectedConinueWithSameProductId == 0) {
    //        return false;
    //    }
    //    $.each(this.products, (i, product) => {
    //        if (product.Id == productId && product.PriceLists.find(x => x.Id == this.selectedConinueWithSamePriceListId)) {
    //            let prod = { Id: this.selectedConinueWithSameProductId } as IProductViewModel;
    //            let prList = { Id: this.selectedConinueWithSamePriceListId } as IPriceListViewModel;
    //            this.selectProduct({ product: prod, priceList: prList })
    //                .then(() => {
    //                    this.productSelected(prod, prList);
    //                    return true;
    //                });
    //        }
    //    });
    //    return false;
    //}

    shortProductNames = ["oiva", "optimi", "vihreä", "priima"];
    getProductImageIdentifier(productName: string) {
        let prefix = "pks-product-";
        let retVal = "";
        if (productName) {
            $.each(this.shortProductNames, (i, item) => {
                if (productName.toLowerCase().includes(item)) {
                    retVal = prefix + item;
                }
            })
        }
        return retVal;
    }

    isPriimaProduct(productid: number): boolean {
        return this.contractSettings.PriimaProductId && this.contractSettings.PriimaProductId > 0
            && productid == this.contractSettings.PriimaProductId;
    }
    isPriimaPlusProduct(productid: number): boolean {
        return this.contractSettings.PriimaPlusProductId && this.contractSettings.PriimaPlusProductId > 0
            && productid == this.contractSettings.PriimaPlusProductId;
    }

    data() {
        return {
            selected: 'showAllProds',            
            options: [
                { text: this.$t('Määräaikainen sopimus (hinta pysyy samana koko sopimuksen voimassaoloajan)'), value: 'isFixedTerm' },
                { text: this.$t('Toistaiseksi voimassa oleva sopimus (hinta voi vaihdella maltillisesti sähkömarkkinahinnan mukaan)'), value: 'notFixedTerm' },
                { text: this.$t('Hinnan määräytymisellä ei ole väliä'), value: 'showAllProds' }
            ]
        }
    }
}